import { useLocation, useNavigate } from 'react-router-dom';

import Header from 'components/common/Header';
import { isValidIndex } from 'utils/numberUtils';

const PreviewHeader: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const page = isValidIndex(location.state?.page) ? location.state.page : null;
  const creativeSetPage = isValidIndex(location.state?.creativeSetPage) ? location.state.creativeSetPage : null;

  const handleBack = (): void => {
    if (creativeSetPage !== null) {
      navigate(`/content-management/creative-sets?creativeSetPage=${creativeSetPage}`);
      return;
    }
    if (page) {
      navigate(`/content-management/creatives?page=${page}`);
    } else {
      navigate('/content-management/creatives');
    }
  };

  return <Header title="Content management" onBackClick={handleBack} />;
};

export default PreviewHeader;
